import type { ReactNode } from "react";
import styles from "./Chip.module.css";

interface ChipProps {
  children: ReactNode;
  /** Selected (pressed) state — flips to the inverse fill. */
  selected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  "aria-label"?: string;
  className?: string;
}

/**
 * Chip — Figma node 273:10299. Pill-shaped toggle, button-md height.
 * Unselected: action-default fill, border-default hairline, regular
 * foreground. Selected: action-inverse-default fill, border-inverse
 * hairline, semibold inverse glyph. Used for multi-select compass
 * directions in the Suggest-a-spot modal; suitable wherever a small
 * toggleable tag is needed.
 */
export function Chip({
  children,
  selected = false,
  onClick,
  disabled,
  "aria-label": ariaLabel,
  className,
}: ChipProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={selected}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onClick}
      className={[styles.chip, selected ? styles.selected : null, className]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </button>
  );
}
